import React from "react";
import MyBet from "../../casinoComponents/myBet";
import { formatPatti2Nation, formatBetOdds } from "../../../utils/casinoMyBets";
import { Teen20RulesCard } from "../teen20/Teen20RightSide";

/** Color Plus payouts shown by the reference RightSideBar (from its casino/rules API) for 2 Cards Teenpatti. */
const COLOR_PLUS_RULES = [
  ["Three card Sequence", "1 TO 3"],
  ["Four card color", "1 TO 9"],
  ["Four card Sequence", "1 TO 9"],
  ["Three of a kind", "1 TO 12"],
  ["Three card pure Sequence", "1 TO 15"],
  ["Four card pure Sequence", "1 TO 150"],
  ["Four of a kind", "1 TO 200"],
];

/** Right sidebar for 2 Cards Teenpatti: My Bets + Rules card ("Color Plus Rules"), reference RightSideBar. */
export default function Patti2RightSide({ bets, onViewMore }) {
  return (
    <>
      {/* reference names ("Total A-95") and a Total bet's line as its rate */}
      <MyBet bets={bets.map((b) => ({ ...b, selection: formatPatti2Nation(b.selection, b), odds: formatBetOdds("patti2", b, b.odds) }))} onViewMore={onViewMore} />{" "}
      <Teen20RulesCard rules={COLOR_PLUS_RULES} heading="Color Plus Rules" />
    </>
  );
}
